import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import './styles/mobileFormFix.css'; // Vylepšenia pre mobilné zariadenia
import './styles/phoneInput.css'; // Štýly pre telefónny vstup
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
